import {Node} from 'gojs';

import {transaction} from 'src/util/gojs/transaction';

export const highlightConnections = (node: Node) => {
  // highlight all Links and Nodes coming out of a given Node
  const diagram = node.diagram;
  if (!diagram) {
    throw new Error('Could not get diagram reference from node');
  }

  transaction('highlight', diagram, () => {
    diagram.clearHighlighteds();

    // for each Link coming out of the Node, set Link.isHighlighted
    node.findLinksOutOf().each(function(l) {
      l.isHighlighted = true;
    });
    // for each Node destination for the Node, set Node.isHighlighted
    node.findNodesOutOf().each(function(n) {
      n.isHighlighted = true;
    });
    // for each Node destination for the Node, set Node.isHighlighted
    node.findNodesInto().each(function(n) {
      n.isHighlighted = true;
    });
    // for each Node destination for the Node, set Node.isHighlighted
    node.findLinksInto().each(function(n) {
      n.isHighlighted = true;
    });
  });
};
